import { Bet, BetGroup } from '@/models/host/BetAmount';
import {
    getTableBetByHostId,
    tableBetSliceActions,
} from '@/modules/betTable/slice';
import store from '@/store/store';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { CMDSpNewBlackjackStandUp, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpNewBlackjackStandUpHandler extends AbstractHandler {
    _command: CMDSpNewBlackjackStandUp;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpNewBlackjackStandUp;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        if (this._command.Reason === this.SUCCESS_CODE) {
            const state = store.getState();
            // const { PlayerID } = getMainUserState(state);
            //Handle standup with bet-behind
            let newBetGroups = [] as BetGroup[];
            const { PlayerBets, BetSeqId, isBetConfirmed } =
                getTableBetByHostId(state, this._command.HostID);
            // let standupFailWithBet =
            //     PlayerID === this._command.PlayerID &&
            //     this._command.Reason === GameError.InvalidInput;
            if (!isBetConfirmed) {
                if (PlayerBets) {
                    PlayerBets.forEach(betGroup => {
                        let newBets = [] as Bet[];
                        betGroup.bets.forEach(v => {
                            if (v.Type % 10 !== this._command.SeatNum) {
                                newBets.push(v);
                            }
                        });
                        if (newBets.length > 0) {
                            newBetGroups.push({
                                index: betGroup.index,
                                bets: newBets,
                            } as BetGroup);
                        }
                    });
                }

                if (
                    JSON.stringify(PlayerBets) !== JSON.stringify(newBetGroups)
                ) {
                    dispatch(
                        tableBetSliceActions.doBJHandleStandBets({
                            hostId: this._command.HostID,
                            gameId: this._command.GameID,
                            playerBets: newBetGroups,
                            betSeqId: BetSeqId,
                        })
                    );
                }
            }
        }
    }
}
